import {Link, useOutletContext} from "react-router-dom";
import {useEffect} from "react";

function ContactPage() {
    const [setTitle, setCount] = useOutletContext<any>();

    useEffect(() => {
        setTitle('Kontakta oss');
        setCount(null);
    }, []);

    return (
        <div>
            <div className="w-full bg-white py-8 xl:py-16">
                <div className="container max-w-3xl font-sweing">
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        Har du frågor eller vill ha mer information om Ingenjörskompassen går det alltid bra att kontakta <Link className="underline" to="mailto:medlem@sverigesingenjorer.se">medlem@sverigesingenjorer.se</Link>. Skriv gärna i ämnesraden vad frågan gäller.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        Har du problem med tjänsten, kontakta oss gärna direkt på <Link className="underline" to="mailto:webmaster@sverigesingenjorer.se?subject=Ingenjörskompassen">webmaster@sverigesingenjorer.se</Link>.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ContactPage;